import React from "react";
import { ApolloConsumer } from "@apollo/client";
import { useNavigate } from "react-router-dom";

// Custom.
import Layout from "containers/Layout/Layout";
import { Form } from "@vocollege/components";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import {
  GET_GROUPS_ROLE,
  UPDATE_GROUPS_ROLE,
  CREATE_GROUPS_ROLE,
} from "@vocollege/app/dist/modules/VoApi/graphql";
import { regexPatterns } from "@vocollege/app";

const initialState = {
  id: 0,
  name: "",
  label: "",
};

export default function GroupsRoleEdit() {
  const navigate = useNavigate();

  const handleRedirect = (state: any) => {
    navigate("/groups/roles");
  };

  return (
    <ApolloConsumer>
      {(client) => (
        <Layout>
          <Form
            client={client}
            tabs={[
              {
                key: "content",
                label: I18n.get.misc.content,
                fields: [
                  {
                    name: "name",
                    label: I18n.get.acl.labels.name,
                    type: "text",
                    required: true,
                    grid: {
                      xs: 12,
                    },
                    validation: {
                      required: true,
                      pattern: {
                        value: regexPatterns.cleanName,
                        message: I18n.get.acl.errors.invalidName,
                      },
                    },
                  },
                  {
                    name: "label",
                    label: I18n.get.acl.labels.label,
                    type: "text",
                    required: true,
                    grid: {
                      xs: 12,
                    },
                    validation: {
                      required: true,
                    },
                  },
                ],
              },
            ]}
            labels={{
              loading: I18n.get.form.labels.loadingContent,
              create: I18n.get.form.labels.createRole,
              created: I18n.get.acl.messages.roleSaved,
              updated: I18n.get.acl.messages.roleSaved,
              deleted: I18n.get.acl.messages.roleDeleted,
              fieldRequired: I18n.get.form.errors.required,
            }}
            operations={{
              category: "groupsRole",
              get: GET_GROUPS_ROLE,
              create: CREATE_GROUPS_ROLE,
              update: UPDATE_GROUPS_ROLE,
            }}
            // paths={{
            //   back: "/groups/roles",
            // }}
            initialState={initialState}
            pageTitleField="label"
            classes={{
              paper: "vo-global__content-with-toolbar",
              toolbar: "vo-global__content-toolbar",
            }}
            onComplete={handleRedirect}
            onCancel={handleRedirect}
          />
        </Layout>
      )}
    </ApolloConsumer>
  );
}
